import React, { Component } from 'react';
import Vas from '../Vas';

class NoPaymentOffline extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

    }

   render()
    {
        return ( <div className={"contractContainer"}>
          <div className={"form"} style={{ textAlign:"justify", maxWidth:"400px" }}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["NoPaymentTechnicalReasons"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default NoPaymentOffline;
